import { useList, useGetList, ListContextProvider } from 'react-admin'
import PropTypes from 'prop-types'
import ComponentWrapper from './ComponentWrapper'
import TableLayout from './TableLayout'

export default function HighCap({ userId }) {
  const { data, isPending } = useGetList('quote-requests', {
    pagination: { page: 1, perPage: 1000 },
    filter: {
      status: 'New inquiry',
      mainUser: userId,
      archived: false,
      'tags.tagName': 'DISTRO',
    },
    sort: {
      field: 'leadContact.vehicle.vehicleSalvage.currentCapValue',
      order: 'DESC',
    },
  })

  const listContext = useList({
    data,
    isPending,
    perPage: 10,
  })

  // Dont show section if data empty
  if (isPending || data === undefined || data.length === 0) {
    return <></>
  }

  return (
    <ComponentWrapper title={'High cap'}>
      <ListContextProvider value={listContext}>
        <TableLayout userId={userId} />
      </ListContextProvider>
    </ComponentWrapper>
  )
}

HighCap.propTypes = {
  userId: PropTypes.string,
}
